var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "white",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5418 14.4719L27.1278 17.4146V23.3L31.5418 26.2427V14.4719Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0268 13H10.158C8.96616 13 8 13.9411 8 15.1019V25.6115C8 26.7724 8.96616 27.7135 10.158 27.7135H22.0268C23.2187 27.7135 24.1848 26.7724 24.1848 25.6115V15.1019C24.1848 13.9411 23.2187 13 22.0268 13Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.158 13.5H22.0268V12.5H10.158V13.5ZM22.0268 13.5C22.955 13.5 23.6848 14.2295 23.6848 15.1019H24.6848C24.6848 13.6526 23.4823 12.5 22.0268 12.5V13.5ZM23.6848 15.1019V25.6115H24.6848V15.1019H23.6848ZM23.6848 25.6115C23.6848 26.4839 22.955 27.2135 22.0268 27.2135V28.2135C23.4823 28.2135 24.6848 27.0609 24.6848 25.6115H23.6848ZM22.0268 27.2135H10.158V28.2135H22.0268V27.2135ZM10.158 27.2135C9.22982 27.2135 8.5 26.4839 8.5 25.6115H7.5C7.5 27.0609 8.7025 28.2135 10.158 28.2135V27.2135ZM8.5 25.6115V15.1019H7.5V25.6115H8.5ZM8.5 15.1019C8.5 14.2295 9.22982 13.5 10.158 13.5V12.5C8.7025 12.5 7.5 13.6526 7.5 15.1019H8.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOn);
export default __webpack_public_path__ + "static/media/video_on.30dc027c982ce4c7933273fc82c27415.svg";
export { ForwardRef as ReactComponent };